document.addEventListener('DOMContentLoaded', function() {
  var faqItems = document.querySelectorAll('.apexwolf-faq__item');

  faqItems.forEach(function(item) {
    var button = item.querySelector('.apexwolf-faq__question');

    button.addEventListener('click', function() {
      var isOpen = item.classList.contains('is-open');

      faqItems.forEach(function(otherItem) {
        otherItem.classList.remove('is-open');
        otherItem.querySelector('.apexwolf-faq__question').setAttribute('aria-expanded', 'false');
      });

      if (!isOpen) {
        item.classList.add('is-open');
        button.setAttribute('aria-expanded', 'true');
      }
    });
  });
});
